export const signUpMsgSuccess = 'Success, you have been signed up'

export const signUpMsgError = 'An account already exists using this email. Please log in instead'

export const resetPasswordMsgSuccess = 'Success, your password has been reset'

export const resetPasswordMsgError =
  'Reset password link expired. Please click on forgot password to reset your password'

export const forgotPasswordMsgSuccess = 'Success, an email was sent to you'

export const forgotPasswordMsgError = 'Account does not exist. Please signup instead'
export const somethingWentWrong = 'Something went wrong, please try again later'

export const logInError401 = `Sorry, that password is incorrect. We can help you recover your password by clicking 'Forgot'.`
export const logInError403 = `Looks like you haven't verified your email yet. Please log into your email account and look for the verification email that was sent by GameDay and follow the prompts.`
export const logInError400 = `Sorry, we couldn't find an account with that email. Try another or 'Sign Up' for a new account`
export const loginErrorAbnormal = 'Sorry, we detected some abnormal bahaviour.'
export const resendVerificationEmailSuccess =
  'Email sent successfully. Please click the verification link on the email.'
